import { EnumLiteralsOf } from '../types/helpers'

export const UserRoles = {
  FREE_USER: 'mybib',
  PRO_USER: 'mybibpro',
  NOT_LOGGED_IN: 'not_logged_in',
} as const

export type UserRole = EnumLiteralsOf<typeof UserRoles>

export const authRoutes: string[] = [
  '/login',
  '/upgrade',
  '/register',
  '/logout',
  '/myaccount',
]

export const MIGRATION_STATUSES = {
  complete: 'complete',
  inProgress: 'inProgress',
  other: 'other',
} as const

export const SIGN_OUT = 'sign-out'
